import { apiUrl } from "@/lib/api-client";

/**
 * POST a single file to deal files (same fields as FilesTab uploadOneToDeal).
 */
export async function uploadDealFileClient(
  dealId: string,
  file: File,
  productItemId?: string | null
): Promise<void> {
  const fd = new FormData();
  fd.append("files", file);
  if (productItemId && productItemId.trim() !== "") {
    fd.append("product_item_id", productItemId.trim());
  }
  const r = await fetch(apiUrl(`/api/crm/deals/${dealId}/files`), {
    method: "POST",
    credentials: "include",
    body: fd,
  });
  if (!r.ok) {
    const j = (await r.json().catch(() => ({}))) as { message?: string; error?: string };
    throw new Error(j.message || j.error || `HTTP ${r.status}`);
  }
}
